module.exports = __webpack_public_path__ + "img/sloth-bicycle-background.ff4b4ab.jpg";